import { render } from "./CouponComponent.vue?vue&type=template&id=4f23fde6"
import script from "./CouponComponent.vue?vue&type=script&lang=js"
export * from "./CouponComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__